import { defineMessages } from 'react-intl';

export default defineMessages({
    contingencies: {
        id: 'gateway.views.account-detail.Contingency"',
        defaultMessage: 'Contingency'
    }
});
